import { styled } from '@mui/material/styles';
import CurrencyInput from 'react-currency-input-field';

export type CurrencyMaskedInputVariant = 'default' | 'filter';

export const StyledCurrencyInput = styled(CurrencyInput, {
  shouldForwardProp: (prop) => prop !== 'variantType'
})<{ variantType: CurrencyMaskedInputVariant }>(({ theme, variantType }) => ({
  width: '100%',
  ...(variantType === 'default'
    ? {
        padding: '10px',
        fontSize: '13px',
        border: '1px solid black',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        borderRadius: '10px',
        '&:focus': {
          outline: 'none',
          borderColor: 'black'
        },
        [theme.breakpoints.down('md')]: {
          padding: '8px',
          fontSize: '14px'
        }
      }
    : {
        maxWidth: '200px',
        padding: '0.5rem',
        fontSize: '0.875rem',
        border: '1px solid #ccc',
        borderRadius: '4px',
        '&:focus': {
          outline: 'none',
          borderColor: '#aaa'
        },
        [theme.breakpoints.down('md')]: {
          maxWidth: '100%'
        }
      })
}));
